<template>
	<ty-card>
		<!-- <div class="text-right">
		<ty-button @click="create_new" class="mr-5" :plain="true" type="success" icon="el-icon-plus" size="medium"> افزودن</ty-button>
	</div> -->
		<!-- <el-pagination
          @current-change="getTransactions"
          layout="prev, pager, next"
          :total="count"
          :page-size="32"
          :current-page.sync="page">
    </el-pagination> -->
		<!-- <Header class="mb-2"/> -->
		<ty-table-header @change="getTransactions(1)" v-model="search" title="لیست تراکنش ها" search-placeholder="جستجو در تراکنش ها ...">
			<router-link class="mx-2" :to="{name: 'shop-categories'}">
				<!-- :to="'/shops/'+$route.params.instance+'/inventory/categories'" -->
				<!-- <ty-button type="outline" color="shadow" icon="ty-icon-filter" size="small"><span
						class="ty-color-dark">فیلتر کردن لیست</span></ty-button> -->
			</router-link>
		</ty-table-header>
		<ty-table :row-class-name="tableRowClassName" @row-dblclick="gotoTransaction" class="transactions"
			:data="transactions" :border="true" :show-summary="true" :summary-method="getSummaries" stripe
			:span-method="spanMethod">
			<!-- <ty-table-column prop="name" label="نام تراکنش" sortable min-width="100" /> -->
			<ty-table-column prop="date_created" label="تاریخ" sortable min-width="90px">
				<template slot-scope="props">
					{{props.dateCreated | date}}
				</template>
			</ty-table-column>
			<ty-table-column prop="type" label="نوع تراکنش" min-width="100px">
				<template slot-scope="props">
					{{props.type|invoiceTypeToName}}
				</template>
			</ty-table-column>
			<ty-table-column prop="product_name" label="جنس" min-width="120px">
				<!-- <template slot-scope="props">
					<SelectProduct v-model="props.product_id" :instance="instance" :product="props.product" />
				</template> -->
			</ty-table-column>
			<ty-table-column prop="count" label="تعداد" min-width="50px">
				<template slot-scope="props">
					<ty-editable-number v-model="props.count" />
				</template>
			</ty-table-column>
			<ty-table-column prop="value" label="قیمت واحد" min-width="100px">
				<template slot-scope="props">
					<ty-editable-number :is_currency="true" v-model="props.value"
						:class="props.type=='sold'?'green':'red'" />
				</template>
			</ty-table-column>
			<!-- <ty-table-column min-width="160">
				<template slot-scope="scope" slot="header">
					<ty-input :data="scope" @input="getTransactions(1)" v-model="search" size="mini"
						placeholder="جستجو" />
				</template>
			</ty-table-column> -->

			<!-- <div slot="append">
		<el-form :inline="true">
			<el-form-item>
				<ty-input v-model="new_transaction.name"/>
			</el-form-item>
			<EditableText v-model="new_transaction.description"/>
		</el-form>
	</div> -->
		</ty-table>
		<el-pagination class="text-center" @current-change="getTransactions" layout="prev, pager, next" :total="count" :page-size="32"
			:current-page.sync="page">
		</el-pagination>
	</ty-card>
</template>

<script>
	// import SelectProduct from '../product/SelectProduct';
	// import Header from './TransactionTableHeader';
	import date from '@/mixins/date';
	import {
		Cirus
	} from '@/classes/Http';
import { InvoiceType } from '@/classes/TayehApi/Instance';
import { Instance } from '@/classes/TayehApi';
	export default {
		props: ['instance'],
		components: {
			// SelectProduct,
			// Header
		},
		filters: {
			date,
			invoiceTypeToName (type) {
				return {
					sold: 'فروش',
					bought: 'خرید',
				}[type]
			}
		},
		data() {
			return {
				transactions: [],
				new_transaction: {},
				count: 0,
				loading: false,
				page: 1,
				new_key: 0,
				instance_id: null,
				search: ''
			}
		},
		methods: {
			async getTransactions(page = this.page) {
				this.transactions = [];
				this.loading = true;
				if (typeof page === 'number') this.page = page;
				const res = await Instance.getInstanceTransactions(this.instance, {types: [InvoiceType.BOUGHT, InvoiceType.SOLD], search: this.search, page: this.page-1});
				this.transactions = (await res.data).transactions;
				this.count = (await res.data).count;
				this.loading = false;
			},
			gotoTransaction() {
				// this.$router.push(`/transactions/${transaction.id}/transactions/`);
			},
			async update(transaction) {
				this.loading = true;
				try {
					await Cirus.post(
						`/instance/${this.instance}/transaction/update/`,
						transaction,

					);
					this.$message({
						showClose: true,
						message: 'تراکنش با موفقیت ویرایش شد.',
						type: 'success',
						duration: 5000
					});
				} catch (err) {
					this.$message({
						showClose: true,
						message: 'لطفا دوباره تلاش کنید.',
						type: 'error',
						duration: 5000
					});
				} finally {
					this.loading = false;
				}
			},
			async askForDelete(transaction) {
				try {
					await this.$confirm('آیا میخواهید این تراکنش را حذف کنید؟', {
						title: 'حذف تراکنش',
						confirmButtonText: 'بله',
						cancelButtonText: 'خیر'
					})
					this._delete(transaction);
				} catch (err) {
					return;
				}
			},
			async _delete(transaction) {
				this.loading = true;
				try {
					await Cirus.delete(
						`/instance/${this.instance}/transaction/${transaction.id}`,

					);
					this.$message({
						showClose: true,
						message: 'تراکنش با موفقیت حذف شد.',
						type: 'success',
						duration: 5000
					});
				} catch (err) {
					this.$message({
						showClose: true,
						message: 'لطفا دوباره تلاش کنید.',
						type: 'error',
						duration: 5000
					});
				} finally {
					this.loading = false;
					this.getTransactions()
				}
			},
			// async delete(transaction) {
			//   this.loading = true;
			//     await Cirus.delete (
			// 		`/transaction/`,
			// 		{id: transaction.id}
			//     );        
			// 	this.loading = false;
			// 	this.getTransactions();
			// },
			tableRowClassName(obj) {
				if (obj.row.id == null) {
					return 'success-row-light';
				}
				//  else if (obj.row.type== 'sell') {
				// 	return 'success-row-light';
				// } else if (obj.row.type == 'buy') {
				// 	return 'danger-row-light';
				// }
				// else if (row.stock_quantity <= 1) {
				//   return 'danger-row';
				// }
				return '';
			},
			getSummaries() {
				const sums = [];
				let buy_total = 0;
				this.transactions.forEach(e => {
					if (e.type == 'buy') buy_total += e.value * e.count;
				})
				sums[1] = `- خرید: ${this.$options.filters.currency(buy_total)}`;

				let sell_total = 0;
				this.transactions.forEach(e => {
					if (e.type == 'sell') sell_total += e.value * e.count;
				})

				sums[2] = `+ فروش: ${this.$options.filters.currency(sell_total)}`;

				const profit = sell_total - buy_total;
				if (profit > 0) {
					sums[3] = `سود: ${this.$options.filters.currency(profit)}`
				} else {
					sums[4] = `ضرر: ${this.$options.filters.currency(profit)}`
				}
				return sums;
			},
			spanMethod({
				row,
				columnIndex
			}) {
				if (!row.id) {
					if (columnIndex === 0)
						return [0, 0]
					else if (columnIndex === 1)
						return [1, 2]
					else if (columnIndex === 4)
						return [1, 2]
					else if (columnIndex === 5)
						return [0, 0]
				} else if (row.type == 'sell') {
					if (columnIndex === 4)
						return [1, 2]
					else if (columnIndex === 5)
						return [0, 0]
				}
				return [1, 1]
			},
		},
		mounted() {
			this.getTransactions();
		}
	}
</script>

<style scoped>
	.el-table+.transaction {
		margin-top: 1.5rem;
	}

	[contenteditable] {
		outline: none;
		padding: 4px;
		margin: auto;
		box-sizing: border-box;
	}

	[contenteditable]:focus {
		border: 1px solid #eee;
	}

	.el-table__footer td:first-child .cell {
		color: blue;
	}

	.red {
		color: red;
	}

	.green {
		color: green;
	}
</style>